import { Route, Routes } from "react-router-dom"
import { RequireAuth, RequireAuthAdm, RequireAuthGestao } from "../contexts/AuthProvider/RequireAuth"
import { Usuario } from "../pages/Usuario"
import { Grupo } from "../pages/Grupo"
import { CredenciaisLooker } from "../pages/CredenciaisLooker"
import { Dashboard } from "../pages/Dashboard"
import { GrupoEmpresa } from "../pages/Grupo/GrupoEmpresa"
import { Categoria } from "../pages/Anomalias/Categoria"
import { Causa } from "../pages/Anomalias/Causa"

export const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<RequireAuth><Dashboard /></RequireAuth>} />
            <Route path="/usuario" element={<RequireAuthGestao><Usuario /></RequireAuthGestao>} />
            <Route path="/grupo" element={<RequireAuthAdm><Grupo /></RequireAuthAdm>} />
            <Route path="/grupoempresa" element={<RequireAuthAdm><GrupoEmpresa /></RequireAuthAdm>} />
            <Route path="/querylooker" element={<RequireAuthGestao><CredenciaisLooker /></RequireAuthGestao>} />
            <Route path="/categoria" element={<RequireAuthGestao><Categoria /></RequireAuthGestao>} />
            <Route path="/causa" element={<RequireAuthGestao><Causa /></RequireAuthGestao>} />
        </Routes>
    )
}